import { Link } from "react-router-dom";
import Button from "../Button";
import { ReactComponent as EcoIcon } from "./eco-numerique-b2b-grey.svg";
import { ReactComponent as Enter } from "./enter.svg";

const SignoutPage = () => {
  return (
    <div className="bg-[#EAEFFF] flex items-center justify-center h-lvh w-full text-center">
      <div>
        <EcoIcon />
        <div className="text-gradient-orange-red bg-gradient-to-l font-bold text-3xl mt-2xl mb-m">
          You're All Signed Out!
        </div>
        <div className="mb-2xl">
          You've successfully logged out of your account.
        </div>
        <div className="flex gap-l items-center">
          <div className="font-bold">Forgot something?</div>
          <Link to={process.env.REACT_APP_LOGIN_URL || ""}>
            <Button
              size="l"
              variant="primary"
              leftComponent={<Enter className={"size-full text-white"} />}
              data-testid="login-button"
            >
              Log in again
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignoutPage;
